import { useCallback } from "react";
import posthog from "posthog-js";
import { useSelector } from "react-redux";

export default function useTrackEvent() {
	const roles = useSelector(({ context }) => context.roles);
	const projectId = useSelector(({ context }) => context.project?.id || null);
	const companyId = useSelector(({ context }) => context.company?.id || null);
	return useCallback(
		(event, properties = {}) => {
			if (!posthog.has_opted_out_capturing()) {
				posthog.capture(event, {
					...properties,
					companyRoles: roles?.COMPANY,
					projectRoles: roles?.PROJECT,
					companyId,
					projectId,
				});
			}
		},
		[roles, companyId, projectId]
	);
}
